// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30-4o","col":"styles_col__3Pjg1"};